import { z } from "zod/v4";

import { OrganizationSummaryDtoSchema } from "../../../dtos/organization-summaries";

export const GetAllOrganizationAgencyLinksByAgencyIdRequestPathParamSchema =
  z.object({
    agencyId: z.uuid(),
  });

export type GetAllOrganizationAgencyLinksByAgencyIdRequestPathParamType =
  z.infer<typeof GetAllOrganizationAgencyLinksByAgencyIdRequestPathParamSchema>;

export const GetAllOrganizationAgencyLinksByAgencyIdResponseBodySchema =
  z.object({
    orgs: OrganizationSummaryDtoSchema.array(),
  });

export type GetAllOrganizationAgencyLinksByAgencyIdResponseBodyType = z.infer<
  typeof GetAllOrganizationAgencyLinksByAgencyIdResponseBodySchema
>;
